import React, { useEffect, useState, useContext, useRef } from 'react'; /*st48236 - 508 compliance*/
import { Accordion } from 'react-bootstrap';
import "../assets/css/Style.css";
import "../styles/accordian.css";
import "../assets/css/feather.css"
import { getApiService } from '../services/ApiService';
import { GetPayLoad } from "../services/PayLoadStorage";
import parse from 'html-react-parser';
import { LanguageContext } from "../contexts/LanguageContext";
import DOMPurify from 'dompurify';

const LanguageProficiency = () => {

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const Payload = GetPayLoad('PayLoad');

  const [activeKey, setActiveKey] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const { pageContent } = useContext(LanguageContext);
  const [limitedProfContent, setLimitedProfContent] = useState([]);
  const mainRef = useRef(null); // Reference for the live region /*st48236 - 508 compliance*/
  const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
  const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed

  useEffect(() => {

    if (pageContent?.limitedproficiency) {
      setLimitedProfContent(pageContent.limitedproficiency);
    }

    const headers = {
      "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
      "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
      "X-Hps-Region": Payload?.region
    };

    const targetUrl = process.env.REACT_APP_API_GET_LANGAUGE_ACCESS_LIST_ENDPOINT;
    getApiService(baseUrl, targetUrl,
      {
        title: 'language-access',
        site_cd: Payload?.site_cd || '',
        lang: 'eng'
      },
      headers
    )
      .then((response) => {
        if (response?.data && response?.data?.status === 'SUCCESS') {
          const result = response.data.data;
          setLanguages(result);
          setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed 
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });

  }, [Payload?.region, baseUrl, pageContent]);

  const filteredLanguages = languages.filter(lang =>
    lang.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const nonDescContent = DOMPurify.sanitize(limitedProfContent?.limited_prof_non_desc_content);

  /*st48236 - 508 compliance*/
const userInteractedRef = useRef(false);

      useEffect(() => {
        const handleUserInteraction = () => {
          userInteractedRef.current = true;   // ref → no re-render
        };
        document.addEventListener('click', handleUserInteraction);
        document.addEventListener('keydown', handleUserInteraction);
        return () => {
          document.removeEventListener('click', handleUserInteraction);
          document.removeEventListener('keydown', handleUserInteraction);
        };
      }, []);

      useEffect(() => {
        let timeoutId;
        if (apiCallsCompleted && !isContentReady) {
          timeoutId = setTimeout(() => {
            setContentReady(true);
      const activeEl = document.activeElement;
      const isEditingField =
        activeEl &&
        (activeEl.tagName === 'INPUT' ||
         activeEl.tagName === 'TEXTAREA' ||
         activeEl.tagName === 'SELECT' ||
         activeEl.isContentEditable);

      if (!userInteractedRef.current && !isEditingField && mainRef.current) {
        requestAnimationFrame(() => {
          mainRef.current.focus({ preventScroll: true });
        });
      }
    }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
  }
        return () => { if (timeoutId) clearTimeout(timeoutId); };
      }, [apiCallsCompleted, isContentReady]);   // userInteracted removed from deps
  
  /*st48236 - 508 compliance*/

  return (
    <>
    <main
          role="main"
          tabIndex="-1" // Make the <main> tag focusable
          ref={mainRef} // Attach the ref to the <main> tag
          style={{ outline: 'none' }} // revmove border
          aria-label="Language Access Search"
          className="language-proficiency-content"
      > {/*st48236 - 508 compliance*/}
      <div className="conatiner-fluid content-inner mt-n5 py-0">
        <div className="card px-3 mt-5">
          <div className="lang-search mb-4 mt-5">
            <input
              type="text"
              aria-label="Search Language"
              className="form-control1 lang-input"
              placeholder="Language..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ pointerEvents: 'auto' }}
            />
            <i className="fe fe-search lang-icon position-absolute start-14 end-0 top-50" style={{ pointerEvents: 'none' }}></i>
          </div>
          <div className="col-12 lang-prof-container content-gloss border-bottom pb-5">
            <div className="lang-prof-accordion-column mt-4">
              {filteredLanguages.map((lang, index) => (
                <Accordion
                  key={index}
                  activeKey={activeKey}
                  onSelect={(eventKey) => setActiveKey(eventKey === activeKey ? null : eventKey)}
                  className=""
                  flush
                >
                  <Accordion.Item eventKey={index.toString()} className="accordion-card langcontent">
                    <Accordion.Header className="accordion-head gap-3">
                      <div className="accordion-header-content">
                        <h2 className="me-2 langheader">{parse(lang.label)}</h2>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="tablecard">
                      <div className="accordion-body px-2">
                        <div className="col-xl-12 px-1" tabIndex={0}>
                          <p className="lh-base px-4 mb-0 languageparagraph">{parse(lang.content)}</p>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              ))}
              {filteredLanguages.length === 0 && (
                <p tabIndex={0} className="text-muted mt-3">{limitedProfContent?.limitedproficiency_no_lang_found_text}</p>
              )}
            </div>
            <div tabIndex={0} className="lang-prof-notice-column">{parse(nonDescContent)}</div>
          </div>
          <div tabIndex={0} className="content-gloss mt-s2 px-3 mt-5" id="language-access-contact-us">
            <h3>{limitedProfContent?.limitedproficiency_lang_access_contactus_text}</h3>
            {/* <!-- CivilRights --> */}
            <div>
              <h4 className="mt-3">{limitedProfContent?.limitedproficiency_office_civil_rights_text}</h4>
			        {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_lang_civil_rights_contact_info_text))}
            </div>
            {/* <!-- A --> */}
            {/* <!-- OCR --> */}
            <div className="mt-4">
              <h4 className="mt-3">{parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_ocr_regional_offices_text))}</h4>
              <h5 className="mt-2">{parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_new_england_region_office_civil_rights_text))}</h5>
              {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_ocr_reg_civil_rights_contact_info_text))}
            </div>
            {/* <!-- OCR --> */}
            {/* <!-- Eastern --> */}
            <div className="mt-4">
              <h4 className="mt-3">{parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_east_caribbean_region_text))}</h4>
				      {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_east_caribbean_reg_contact_info_text))}
            </div>
            {/* <!-- Eastern --> */}
            {/* <!-- Mid-Atlantic Region --> */}
            <div className="mt-4">
              <h4 className="mt-3">
				      {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_mid_atlantic_reg_text))}
              </h4>
              {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_mid_atlantic_reg_contact_info_text))}
            </div>
            {/* <!-- Mid-Atlantic Region --> */}
            {/* <!-- Southeast Region --> */}
            <div className="mt-4">
              <h4 className="mt-3">
                {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_south_reg_office_civil_rights_text))}
              </h4>
				      {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_south_reg_contact_info_text))}
            </div>
            {/* <!-- Southeast Region --> */}
            {/* <!-- MidWest Region --> */}
            <div className="mt-4">
              <h4 className="mt-3">
			        {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_midwest_reg_office_civil_rights_text))}
              </h4>
			        {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_midwest_reg_contact_info_text))}
            </div>
            {/* <!-- MidWest Region --> */}
            {/* <!-- Kansas --> */}
            <div className="mt-4">
              <h4 className="mt-3">
				      {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_kansas_office_civil_rights_text))}
              </h4>
			        {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_kansas_civil_rights_contact_info_text))}
            </div>
            {/* <!-- Kansas --> */}
            {/* <!-- Southwest Region --> */}
            <div className="mt-4">
              <h4 className="mt-3">
				      {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_southwest_reg_office_civil_rights_text))}
              </h4>
			        {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_southwest_reg_contact_info_text))}
            </div>
            {/* <!-- Southwest Region --> */}

            {/* <!-- Rocky Mountain Region --> */}
            <div className="mt-4">
              <h4 className="mt-3">
				      {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_southwest_reg_contact_info_text))}
              </h4>
			        {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_rocky_mountain_reg_contact_info_text))}
            </div>
            <div className="mt-4">
              <h4 className="mt-3">
				      {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_pacific_region_text))}
              </h4>
			        {parse(DOMPurify.sanitize(limitedProfContent?.limitedproficiency_pacific_region_contact_info_text))}
            </div>
          </div>
        </div>
      </div >
      </main> {/*st48236 - 508 compliance*/}
    </>
  )
}

export default LanguageProficiency;